(function () {
  // ─── Helpers ────────────────────────────────────────────────────────────────

  /** Read the unit price (in cents) stored on the row by Liquid */
  function unitPrice(row) {
    return parseFloat(row.dataset.price, 10);
  }

  /** Current qty value for a row */
  function getQty(row) {
    return parseInt(row.querySelector(".qty-input").textContent, 10);
  }

  /** Recalculate the running total shown in the footer */
  function refreshTotal() {
    const rows = document.querySelectorAll(
      "#bulk-list-body .bulk-order-row:not(.bulk-order-header-row)",
    );
    let total = 0;
    let totalAmount = 0;

    rows.forEach((row) => {
      const isAvailable = row.dataset.available === "true";
      const qty = isAvailable ? getQty(row) : 0;
      const minusBtn = row.querySelector(".qty-btn.minus");
      
      total += qty;
      totalAmount += unitPrice(row) * qty; 
      if(!isAvailable && qty >0)
      {
        row.querySelector(".qty-input").textContent = 0;
      }
      if (minusBtn)
        {
          minusBtn.disabled = qty <= 0;
        }

    });

    const totalCountSpan = document.getElementById("bulk-total-count");
    const footer = document.getElementById("bulk-footer");
    const addToCartBtn = document.getElementById("bulk-add-to-cart");
    // const ageConfirm = document.getElementById("bulk-age-checkbox");
    const totalSpan = document.querySelector(".bulk-total-amount span.amount");


    if (totalCountSpan) totalCountSpan.textContent = total;
    if (footer) footer.classList.toggle("is-visible", total > 0);
    if (addToCartBtn) {
      const buttonText = addToCartBtn.querySelector(".button-text");
      if (buttonText) {
        if (total > 0) {
          
          buttonText.innerHTML = `Add <span id="bulk-total-count">${total}</span> Items to Cart`;
        } else {
          buttonText.innerHTML = "Add items to continue";
        }
      }
      if (total === 0) {
        addToCartBtn.disabled = true;
      } else {
        addToCartBtn.disabled = false;
      }
    }

    totalSpan.textContent = (totalAmount / 100).toFixed(2);
    // totalSpan.textContent = totalAmount.toFixed(2);
  }

  // ─── Quantity update — targeted, no rerender ─────────────────────────────────

  function updateQty(row, delta) {
    const available = row.dataset.available === "true";
    if (!available) return;

    const maxQty =
      row.dataset.maxQty !== "" ? parseInt(row.dataset.maxQty, 10) : null;
    const currentQty = getQty(row);
    let newQty = currentQty + delta;

    if(newQty<0)
    {
      newQty = 0;
    }

    if (maxQty !== null && newQty > maxQty)
    {
      newQty = maxQty;
    }

    // 1. Update input value
    row.querySelector(".qty-input").textContent = newQty;

    // 2. Toggle minus button disabled state
    const minusBtn = row.querySelector(".qty-btn.minus");
    if (minusBtn)
      {
        minusBtn.disabled = newQty <= 0;
      }
    // 3. Toggle plus button disabled state
    const plusBtn = row.querySelector(".qty-btn.plus")
    if (plusBtn && maxQty !== null)
    {
      plusBtn.disabled = newQty >= maxQty;
    }

    //4. Check for maximum quantity enable state
    const stockMsg = row.querySelector(".stock-limit-message");

    if(stockMsg && maxQty !== null)
    {
      stockMsg.classList.toggle("hidden",newQty<maxQty);
    }

    // 5. Refresh footer total
    refreshTotal();
  }

  // ─── Popup window Logic ────────────────────────

  // function openLoginPopup() {
  //   const popup = document.querySelector(".custom-popup");
  //   if(!popup) return;
  //   popup.classList.add("is-active");
  //   popup.hidden = false;
  // }

  // function closeLoginPopup() {
  //   const popup = document.querySelector(".custom-popup");
  //   if (!popup) return;
  //   popup.hidden = true;
  //   popup.classList.remove("is-active");
  // }

  // ─── Wire up event listeners once (event delegation) ────────────────────────

  function initBulkOrder() {
    const addToCartBtn = document.getElementById("bulk-add-to-cart");
    const listBody = document.querySelector(".bulk-order-container");
    
    if (!listBody) return;

    // Use event delegation so listeners survive only once — no rebinding on updates
    listBody.addEventListener("click", function (e) {
      const minusBtn = e.target.closest(".qty-btn.minus");
      const plusBtn = e.target.closest(".qty-btn.plus");
      // const ageConfirm = e.target.closest(".bulk-age-confirm");

      if (minusBtn) {
        const row = minusBtn.closest(".bulk-order-row");
        if (row) updateQty(row, -1);
        return;
      }

      if (plusBtn) {
        const row = plusBtn.closest(".bulk-order-row");
        if (row) updateQty(row, 1);
        return;
      }

      // if (ageConfirm) {
      //   refreshTotal();
      // }
    });
    

    // document.addEventListener("click", (e) => {
    //   // Close popup
    //   if (
    //     e.target.closest(".custom-popupclose")
    //   ) {
    //     closeLoginPopup();
    //   }
    //   // Continue as guest
    //   if (
    //     e.target.closest(".continue-guest")
    //   ) {
    //     window.location.href = "/checkout";
    //   }
    // });

    // Add to cart — collect current state from DOM
    if (addToCartBtn) {
      addToCartBtn.addEventListener("click", () => {
        const rows = listBody.querySelectorAll(
          ".bulk-order-row:not(.bulk-order-header-row)",
        );
        const items = [];

        rows.forEach((row) => {
          const available = row.dataset.available === "true";
          const qty = getQty(row);
          if (available && qty > 0) {
            items.push({ id: Number(row.dataset.id), quantity: Number(qty) });
          }
        });
        
        if (items.length === 0) return;

        const spinner = addToCartBtn.querySelector(".loading-overlay__spinner");
        if (spinner) spinner.classList.remove("hidden");
        addToCartBtn.disabled = true;

        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items }),
        })
          .then((res) => res.json())
          .then(() => {
            return fetch("/cart/update.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                attributes: {
                  bulk_order: "true",
                },
              }),
            });
          })
          .then((res) => res.json())
          .then(() => {
              return fetch("/?sections=cart-drawer,cart-icon-bubble")
                .then((res) => res.json())
                .then((sections) => {
                    const cartIconBubble = document.getElementById("cart-icon-bubble");
                    if(cartIconBubble)
                    {
                      cartIconBubble.innerHTML = new DOMParser()
                        .parseFromString(sections["cart-icon-bubble"], "text/html")
                        .querySelector(".shopify-section").innerHTML;
                    }
                    const cartDrawer = document.getElementById("CartDrawer");
                    if(cartDrawer)
                    {
                      cartDrawer.innerHTML = new DOMParser()
                        .parseFromString(sections["cart-drawer"],'text/html')
                        .querySelector("#CartDrawer").innerHTML;
                    }
                    window.location.href = "/checkout";
                    // if(window.customerLoggedIn)
                    //   {
                    //     
                    //   }
                    //   else{
                    //     openLoginPopup();
                    //   }
                });
          })
          .catch((err) => {
            console.error(err);
            alert("There was an error adding items to the cart.");
            if (spinner) spinner.classList.add("hidden");
            addToCartBtn.disabled = false;
          })
          .finally(() =>{
              if (spinner) spinner.classList.add("hidden");
              addToCartBtn.disabled = false;
          });
      });
    }

    refreshTotal();
  }

  // ─── Boot ────────────────────────────────────────────────────────────────────
  function boot() {
    initBulkOrder();
    accordionInitialize();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();

function accordionInitialize() {
  // Accordion JS
  const headerRows = document.querySelectorAll(".bulk-order-collection-row");

  headerRows.forEach((headerRow) => {
    const bodyRows = [];

    // Get consecutive bulk-order-row siblings
    let next = headerRow.nextElementSibling;

    while (next && next.classList.contains("bulk-order-row")) {
      bodyRows.push(next);
      next = next.nextElementSibling;
    }

    headerRow.addEventListener("click", () => {
      const isOpen = headerRow.classList.toggle("is-open");
      const header = document.querySelector(".header-wrapper");

      bodyRows.forEach((row) => {
        if (isOpen) {
          row.classList.remove("is-hidden");
        } else {
          row.classList.add("is-hidden");
        }
      });
    });
  });
}

// Refresh the cart when user backs to the bulk order page
window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      fetch("/?sections=cart-drawer,cart-icon-bubble")
      .then((res) => res.json())
      .then((sections) => {
          const cartIconBubble = document.getElementById("cart-icon-bubble");
          if(cartIconBubble)
          {
            cartIconBubble.innerHTML = new DOMParser()
              .parseFromString(sections["cart-icon-bubble"], "text/html")
              .querySelector(".shopify-section").innerHTML;
          }
          const cartDrawer = document.getElementById("CartDrawer");
          if(cartDrawer)
          {
            cartDrawer.innerHTML = new DOMParser()
              .parseFromString(sections["cart-drawer"],'text/html')
              .querySelector("#CartDrawer").innerHTML;
          }
      });
    }
});